import { BackofficeGetGroupPromoShiptoList } from '@diamond/shared/types';
import { apiInstance } from '@diamond/shared/utils';
import { useAuthStore } from '@diamond/sol-admin/features/auth';
import { useQuery } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { id } from 'date-fns/locale';

export class BackofficePromoError extends Error {
  status: number | undefined;
  subtitle: string;
  constructor(status: number | undefined, message: string, subtitle: string) {
    super(message);
    this.status = status;
    this.subtitle = subtitle;
  }
}

export const getEndpointExportShiptoList = (id: string) => {
  return `/backoffice/promo/${id}/shipto`;
};

export async function getGroupPromoShiptoList(
  access_token: string,
  promo_id: string
) {
  try {
    const response = await apiInstance(
      access_token
    ).get<BackofficeGetGroupPromoShiptoList>(
      `/backoffice/promo/${promo_id}/shipto`
    );
    return response;
  } catch (error) {
    if (isAxiosError(error)) {
      throw new BackofficePromoError(
        error.response?.data.statusCode,
        error.response?.data.message,
        'Silahkan coba lagi'
      );
    }
    throw new BackofficePromoError(
      500,
      'Terjadi Kesalahan',
      'Silahkan coba lagi'
    );
  }
}

export function useGroupPromoShiptoList(promo_id: string, enabled = false) {
  const { access_token } = useAuthStore();
  return useQuery({
    queryKey: ['GroupPromoShiptoList', promo_id],
    queryFn: () => getGroupPromoShiptoList(access_token, promo_id),
    enabled,
  });
}
